<app-page-header icon="medical_services" title="Especialidades" subtitle="Listado de especialidades del sistema"></app-page-header>

<app-spinner [show]="!flagLoaded" [type]="'fullscreen'" [color]="'#B1476A'" [trackColor]="'#4CA7C8'" [text]="'Cargando especialidades...'" [showText]="true" [blurBackground]="true"></app-spinner>

<div *ngIf="flagLoaded" class="profile-area pb-70">
    <div class="container">
        <div class="profile-courses-quizzes">
            <h3>Listado de Especialidades</h3>
            <br>
            <div class="botones-container">
                <a routerLink="/especialidad-alta">
                    <button mat-raised-button mat-button color="primary">
                        <mat-icon aria-hidden="false" aria-label="Example home icon">add</mat-icon>
                        Nueva Especialidad
                    </button>
                </a>
            </div>
            <br>
            <hr>
            <div *ngIf="flagLoaded">

                <mat-form-field>
                    <mat-label>Filtrar</mat-label>
                    <input matInput (keyup)="applyFilter($event)" placeholder="Especialidad..."
                        autocomplete="off" #input style="width: 40%;">
                </mat-form-field>

                <div class="mat-elevation-z8">

                    <table mat-table [dataSource]="dataSource" matSort>

                        <!-- Column -->
                        <ng-container matColumnDef="especialidad">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Especialidad </th>
                            <td mat-cell *matCellDef="let element">
                                {{element.concepto}} </td>
                        </ng-container>

                        <!-- Column -->
                        <ng-container matColumnDef="activa">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Activa</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="toggler">
                                    <input 
                                        type="checkbox" 
                                        [id]="'toggler-' + element._id" 
                                        [checked]="element.logico_1 || false"
                                        (change)="toggleActivo(element, $event)">
                                    <label [for]="'toggler-' + element._id"></label>
                                </div>
                            </td>
                        </ng-container>

                        <!-- Column -->
                        <ng-container matColumnDef="_id">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                Acciones </th>
                            <td mat-cell *matCellDef="let element">
                                <button style="margin-right: 5px;" (click)="verEspecialidad(element._id)"
                                    type="button" title="Modificar datos de la especialidad"
                                    class="btn btn-warning"><i class="fas fa-edit"></i></button>
                            </td>
                        </ng-container>

                        <!-- Columna Refresh -->
                        <ng-container matColumnDef="refresh">
                            <th mat-header-cell *matHeaderCellDef>
                                <button 
                                    (click)="recargarDatos()"
                                    type="button" 
                                    title="Recargar listado"
                                    class="btn-refresh">
                                    <i class="fas fa-sync-alt"></i>
                                </button>
                            </th>
                            <td mat-cell *matCellDef="let element"></td>
                        </ng-container>

                        <!-- Row shown when there is no matching data. -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="4">No data matching
                                the
                                filter {{input.value}}</td>
                        </tr>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns">
                        </tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;" 
                            [class.inactive-row]="!row.logico_1"
                            class="example-element-row">
                        </tr>
                    </table>

                    <mat-paginator [pageSizeOptions]="[50, 100, 150, 200, 500, 800]"
                        aria-label="Select page of campus"></mat-paginator>
                </div>
            </div>
        </div>
    </div>
</div>